import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-level-icon',
  templateUrl: './level-icon.component.html',
  styleUrls: ['./level-icon.component.scss']
})
export class LevelIconComponent {
  @Input('level') level = 0;
}
